// components/Blocks/ContactPersonForm.js
import React from 'react';
import PhoneInput from '../../../../../../cabinet/wizplain/widgets/phone';

const ContactPersonForm = ({ 
  title, 
  data, 
  onChange, 
  editable, 
  personType,
  isViewOnly = false 
}) => {
  const handleFieldChange = (field, value) => {
    if (isViewOnly) return;
    onChange(field, value);
  };

  const formatRnokpp = (val) => {
    const val_match = val.match(/[0-9]/g, '');
    return val_match && val_match.join("").slice(0,10) || '';
  };

  return (
    <div className="contact-person-block">
      <div className="contact-person-header">
        <h6 className="contact-person-title">{title}</h6>
      </div>
      
      <div className="contact-person-fields">
        <div className="row g-3 align-items-start">
          <div className="col-md-4">
            <div className="form-label">Прізвище</div>
            <input
              type="text"
              className="form-control"
              value={data.lastName || ''}
              onChange={(e) => handleFieldChange('lastName', e.target.value)}
              placeholder="Введіть прізвище"
              disabled={isViewOnly || !editable}
            />
          </div>
          
          <div className="col-md-4">
            <div className="form-label">Ім'я</div>
            <input
              type="text"
              className="form-control"
              value={data.firstName || ''}
              onChange={(e) => handleFieldChange('firstName', e.target.value)}
              placeholder="Введіть ім'я"
              disabled={isViewOnly || !editable}
            />
          </div>
          
          <div className="col-md-4">
            <div className="form-label">По батькові</div>
            <input
              type="text"
              className="form-control"
              value={data.middleName || ''}
              onChange={(e) => handleFieldChange('middleName', e.target.value)}
              placeholder="Введіть по батькові"
              disabled={isViewOnly || !editable}
            />
          </div>

          <div className="col-md-6">
            <div className="form-label">Телефон</div>
            <PhoneInput 
              value={data.phone || ''}
              onChange={(e) => handleFieldChange('phone', e.target.value)}
              disabled={isViewOnly || !editable}
            />
          </div>

          <div className="col-md-6">
            <div className="form-label">E-mail</div>
            <input
              type="email"
              className="form-control"
              value={data.email || ''}
              onChange={(e) => handleFieldChange('email', e.target.value)}
              placeholder="Введіть email"
              disabled={isViewOnly || !editable}
            />
          </div>

          <div className="col-md-6">
            <div className="form-label">РНОКПП</div>
            <input
              type="text"
              className="form-control"
              placeholder="3495678801"
              value={data.taxNumber || ''}
              onChange={(e) => handleFieldChange('taxNumber', formatRnokpp(e.target.value))}
              maxLength={10}
              disabled={isViewOnly || !editable}
            />
          </div>

          <div className="col-md-6">
            <div className="form-label">Громадянство</div>
            <select
              className="form-select"
              value={data.citizenship || 'Україна'}
              onChange={(e) => handleFieldChange('citizenship', e.target.value)}
              disabled={isViewOnly || !editable}
            >
              <option value="Україна">Україна</option>
              <option value="Інше">Інше</option>
            </select>
          </div>
          <div className="col-md-6">
              <div className="form-label">Адреса</div>
              <input
                type="text"
                className="form-control"
                value={data.address || ''}
                onChange={(e) => handleFieldChange('address', e.target.value)}
                placeholder="Введіть адресу"
                disabled={isViewOnly || !editable}
              />
            </div>

            <div className="col-md-6">
              <div className="form-label">Viber</div>
              <input
                type="text"
                className="form-control"
                value={data.viber || ''}
                onChange={(e) => handleFieldChange('viber', e.target.value)}
                placeholder="Введіть Viber"
                disabled={isViewOnly || !editable}
              />
            </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPersonForm;